angular.module('impactx.basket').controller('BasketTemplateMenuListCtrl', [
    '$controller',
    BasketTemplateMenuListCtrl]);

function BasketTemplateMenuListCtrl($controller)
{
    angular.extend(this, $controller('SideBarSubMenuCtrl'));
}